// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"599":"ec661b1f","776":"4d356875"}[chunkId] + ".chunk.js";
};